import { useAuthContext } from "providers/Auth";
import { useCountMetaRentReportingController } from "views/rent-reporting/controllers/general-meta-controller";

export const useRentReportingNavCount = () => {
  const { type } = useAuthContext();
  const { needToReportCountMeta, pendingCountMeta } =
    useCountMetaRentReportingController();

  return (type.isSDK ? pendingCountMeta.data : needToReportCountMeta.data) || 0;
};
